import * as React from "react";
import { getOngoingOrders } from "../actions/admin_orders_actions";
import { useDispatch, useSelector } from "react-redux";
import { useInfiniteScroll } from "./useInfiniteScroll";
import { uniqueValueFilterById } from "../functions/helpers/uniqueValueFilterById";
import { useMemo } from "react";

export const useOngoingOrders = () => {
    const dispatch = useDispatch();
    const login = useSelector((state) => state.login);
    const limit = useSelector(
        (state) => state.adminOrders.ongoingOrdersLimit
    );
    let orders = useSelector(
        (state) => state.adminOrders.ongoingOrders
    );
    const loading = useSelector(
        (state) => state.adminOrders.loading
    );
    const ordersCount = useSelector(
        (state) => state.adminOrders.ongoingOrdersCount
    );
    const searchFilter = useSelector(
        (state) => state.adminOrders.ongoingOrdersSearchFilter
    );

    // new: read from URL
    // read from URL whenever it changes
    const [urlOrderNumber, setUrlOrderNumber] = React.useState(null);

    React.useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        setUrlOrderNumber(params.get("order_number"));
    }, [window.location.search]); // re-run when URL changes

    // final merged value — URL param takes priority if present
    const activeSearchFilter = urlOrderNumber || searchFilter;

    const loadMore = React.useCallback(() => {
        if (!ordersCount || orders.length < ordersCount) {
            dispatch(
                getOngoingOrders(activeSearchFilter, login.user.factory_id, limit, orders.length)
            );
            setIsFetching(false);
        }
    }, [activeSearchFilter, login.user.factory_id, limit, orders.length, ordersCount, dispatch]);

    const [isFetching, setIsFetching] = useInfiniteScroll(loadMore);
    orders = uniqueValueFilterById(orders, "_id");

    // Filter orders based on search term
    const filteredOrders = useMemo(() => {
        if (!activeSearchFilter) return orders;

        const searchTerm = searchFilter.trim().toLowerCase();
        return orders.filter(order => {
            const orderNumber = order.order_number?.toLowerCase() || '';
            const clientName = order.client_name?.toLowerCase() || '';
            const customerName = order.customer_name?.toLowerCase() || '';
            const email = order.email?.toLowerCase() || '';
            const mobile = order.mobile?.toLowerCase() || '';

            return orderNumber.includes(searchTerm) ||
                clientName.includes(searchTerm) ||
                customerName.includes(searchTerm) ||
                email.includes(searchTerm) ||
                mobile.includes(searchTerm);
        });
    }, [orders, activeSearchFilter]);

    return [filteredOrders, loading, ordersCount, isFetching, orders.length];
};